import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { SearchableItemModelSection, SearchableSection } from "@/Common/Models/SearchableItem";

interface ITextboxWithSectionsProps {
    id?: string;
    dataCy?: string;
    value?: string;
    name?: string;
    placeholder?: string;

    className?: string;
    style?: React.CSSProperties;

    disabled?: boolean;
    valid?: boolean;
    maxLength?: number;
    maxResults?: number;

    autoCompleteItems: Immutable.List<SearchableItemModelSection<any>>;
    onAutoCompleteSelectCallBack: (Model: any, section: SearchableSection) => void;
    onAutoCompleteSelectClearTextBox?: boolean;
    onAutoCompleteSelectDoNotUpdateTextBox?: boolean;
    onClickRestrictedSearch?: boolean;

    onChange?: (value: string) => void;
    onMountFocus?: boolean;
    footer?: JSX.Element;
    forceHideFooter?: boolean;
}

class TextboxControlWithSectionsState {
    public autoCompleteItemsClean: Immutable.List<SearchableItemModelSection<any>>;
    public autoCompleteItemsMatches: Immutable.List<SearchableItemModelSection<any>>;
    public text: string = "";
    public forceHideDropDown: boolean;
}

class TextboxControlWithSections extends React.Component<ITextboxWithSectionsProps, TextboxControlWithSectionsState> {
    private myleHelper = cacheStore.Helper;
    private id: string;

    private isInFocus = false;
    private isMouseIn = false;
    private isTouching = false;
    private timeoutIsClosing;

    constructor(props: ITextboxWithSectionsProps) {
        super(props);

        const initialState = new TextboxControlWithSectionsState();
        initialState.text = this.props.value ? this.props.value : "";
        initialState.forceHideDropDown = true;

        if (this.props.autoCompleteItems != null)
            initialState.autoCompleteItemsClean = this.props.autoCompleteItems;

        this.state = initialState;
    }

    public componentWillUpdate(nextProps: ITextboxWithSectionsProps): void {
        if (nextProps.value !== this.props.value || nextProps.autoCompleteItems !== this.props.autoCompleteItems) {
            this.mutateState((x: TextboxControlWithSectionsState) => {
                x.text = nextProps.value;
                x.autoCompleteItemsClean = nextProps.autoCompleteItems;
            });
        }
    }

    public componentDidMount(): void {
        let self = this;

        window.setTimeout(() => {
            if (self.props.onMountFocus === true) {
                $("#" + self.id).focus();
                $("#" + self.id).select();
            }
        }, 200);
    }

    public componentWillUnmount(): void {
        if (this.timeoutIsClosing != null)
            clearTimeout(this.timeoutIsClosing);
    }

    private mutateState(mutation: (s: TextboxControlWithSectionsState) => void, then?: () => void): void {
        let s = new TextboxControlWithSectionsState();
        mutation(s);
        this.setState(s, then);
    }

    public render(): JSX.Element {
        this.id = this.props.id;
        if (this.id == null || this.id == "")
            this.id = sessionStore.newId().toString();

        let parentClassName = this.props.valid === false ? "patient-autocomplete invalid" : "patient-autocomplete";
        if (this.props.disabled)
            parentClassName += " disabled";
        let subParentClassName = "patient-search-field";
        let subParentStyle: React.CSSProperties = { height: "37px", paddingTop: "8px" };

        return (
            <div className={parentClassName} style={{ position: "relative" }}>
                <div className={subParentClassName} style={subParentStyle}>
                    <input
                        disabled={this.props.disabled}
                        style={this.props.style}
                        className={this.props.valid === false ? this.props.className + " invalid" : this.props.className}
                        id={this.id}
                        data-cy={this.props.dataCy}
                        type="text"
                        value={this.state.text}
                        placeholder={this.props.placeholder}
                        maxLength={this.props.maxLength}
                        name={this.props.name}
                        onClick={() => this.onClick()}
                        onChange={e => this.onChange(e)}
                        onBlur={() => this.onBlur()}
                        onFocus={() => this.onFocus()}
                    />
                </div>

                {this.renderAutoCompleteList({ zIndex: 2000, position: "absolute", top: subParentStyle.height, left: "-2px", width: "101%" })}
            </div>
        );
    }

    private renderAutoCompleteList(style?: React.CSSProperties): JSX.Element {
        let groupedResults = [];

        const noMatches = !this.props.autoCompleteItems || !this.state.autoCompleteItemsMatches?.count();
        const noFooter = !this.props.footer || this.props.forceHideFooter;

        if ((noMatches && noFooter) || this.state.forceHideDropDown) {
            return null;
        }

        if (this.state.autoCompleteItemsMatches && this.state.autoCompleteItemsMatches.count() > 0) {
            groupedResults = this.state.autoCompleteItemsMatches.count() === 0
                ? []
                : this.state.autoCompleteItemsMatches.toArray()
                    .sortByProperty(x => x.Section ? x.Section.priority : 999)
                    .groupBy((item: SearchableItemModelSection<any>) => item.Section ? item.Section.code : "");
        }

        return (
            <div
                className="list-container-txtbox"
                onMouseEnter={() => this.onMouseEnter()}
                onMouseLeave={() => this.onMouseLeave()}
                onTouchStart={() => this.onTouchStart()}
                onTouchEnd={() => this.onTouchEnd()}
                style={style}
            >
                <div className="results-container" onClick={e => e.stopPropagation()}>
                    <ul className="results-list">
                        {groupedResults.map((group, idx) => {
                            const firstItemInGroup = group.firstOrDefault();
                            let listRender = this.renderItemList(group.toImmutable(), firstItemInGroup.Section ? cacheStore.GetString(firstItemInGroup.Section.title) : "");
                            if (idx < groupedResults.length - 1) listRender.push(<li><hr /></li>);
                            return listRender;
                        })}
                        {this.props.footer && !this.props.forceHideFooter && (
                            <>
                                <li><hr /></li>
                                <li style={{ margin: "5px 5px" }}>{this.props.footer}</li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        );
    }

    private renderItemList(items: Immutable.List<SearchableItemModelSection<any>>, label: string): JSX.Element[] {
        if (!items || items.count() === 0)
            return [];

        let itemsRender = [];
        if (label) {
            itemsRender.push(<h5 style={{ cursor: "default", fontWeight: "bold" }}>{label}</h5>);
        }

        items.forEach((item: SearchableItemModelSection<any>) => {
            let divStyle: React.CSSProperties = item.Active == true ? { "backgroundColor": "#f4f6f9" } : {};

            itemsRender.push(
                (
                    <li
                        key={item.Code + "__code_"}
                        style={{ margin: "5px 5px" }}
                        data-cy={this.props.dataCy ? `${this.props.dataCy}-${item.Code}` : null}
                    >
                        <div className="flex-container" style={divStyle} onKeyDown={e => this.inputKeyDown(e)} onClick={() => this.handleItemSelected(item)}>
                            <a>{item.Value}</a>
                        </div>
                    </li>
                )
            );
        });

        return itemsRender;
    }

    private updateAutocompleteMatches(matches: SearchableItemModelSection<any>[]): void {
        this.mutateState(x => {
            x.forceHideDropDown = false;
            x.autoCompleteItemsMatches = Immutable.List(matches);
        });
    }

    private onClick(): void {
        if (this.props.autoCompleteItems != null) {
            this.mutateState(s => {
                s.forceHideDropDown = !this.state.forceHideDropDown;
                s.text = this.state.text;
                if (!s.forceHideDropDown) {
                    // Toggle on
                    let searchText = (this.props.onClickRestrictedSearch == true) ? this.state.text : "";

                    s.autoCompleteItemsMatches = this.findMatches(searchText).toImmutable();
                }
            });
        }
    }

    private onFocus(): void {
        this.isInFocus = true;
    }

    private onBlur(): void {
        this.isInFocus = false;
        this.tryCloseDropdown();
    }

    private tryCloseDropdown(): void {
        var self = this;
        if (this.timeoutIsClosing !== -1) {
            clearTimeout(this.timeoutIsClosing);
            this.timeoutIsClosing = -1;
        }

        this.timeoutIsClosing = window.setTimeout(() => {
            if (!self.isInFocus && !self.isMouseIn && !self.isTouching)
                self.mutateState(_state => {
                    _state.autoCompleteItemsMatches = [].toImmutable();
                    _state.forceHideDropDown = true;
                    _state.text = this.state.text;
                });
        }, 200);
    }

    private onMouseEnter(): void {
        this.isMouseIn = true;
    }

    private onTouchStart(): void {
        this.isTouching = true;
    }

    private onTouchEnd(): void {
        this.isTouching = false;
        this.tryCloseDropdown();
    }

    private onMouseLeave(): void {
        this.isMouseIn = false;
        this.tryCloseDropdown();
    }

    private onChange(e: any): void {
        let newText = e.target.value;

        let matches: SearchableItemModelSection<any>[] = this.findMatches(newText);

        this.mutateState(s => {
            s.text = newText;
            s.autoCompleteItemsMatches = Immutable.List(matches);
            s.forceHideDropDown = false;
        });

        this.props.onChange?.(newText);
    }

    private findMatches(searchText: string): SearchableItemModelSection<any>[] {
        let matches: SearchableItemModelSection<any>[] = [];

        let cleanText: string = this.myleHelper.RemoveDiacritics(searchText).toLowerCase();
        let splittedSearch = cleanText.split(" ");

        let condition1DefaultFalse: (value: string) => boolean = () => false;
        let conditionDefaultTrue: (value: string) => boolean = () => true;

        if (!isArrayNullOrUndefinedOrEmpty(splittedSearch))
            condition1DefaultFalse = (value: string) => {
                let splittedvalue = value.split(" ");
                return splittedvalue.some(word => word.indexOf(splittedSearch[0]) == 0);
            };

        if (splittedSearch != null && splittedSearch.length > 1)
            conditionDefaultTrue = (value: string) => value.indexOf(splittedSearch[1]) >= 0;

        if (splittedSearch != null && splittedSearch.length > 2)
            conditionDefaultTrue = (value: string) => value.indexOf(splittedSearch[2]) >= 0;

        matches = this.state.autoCompleteItemsClean
            .filter((x: SearchableItemModelSection<any>) => condition1DefaultFalse(x.Value_Searchable) && conditionDefaultTrue(x.Value_Searchable) && conditionDefaultTrue(x.Value_Searchable))
            .toArray();

        matches = ArrayHelper.SortDynamic(matches, "Value").slice(0, this.props.maxResults ?? 12);

        if (matches.length > 0) {
            matches.forEach(x => x.Active = false);
        }

        return matches;
    }

    private inputKeyDown(e: React.KeyboardEvent): void {
        // up
        if (e.keyCode === 38) { e.preventDefault(); this.moveSelectionUpOrDown(true); }

        // down
        if (e.keyCode === 40) { e.preventDefault(); this.moveSelectionUpOrDown(false); }

        // enter
        if (e.keyCode === 13) {
            if (!this.state.forceHideDropDown == true && this.state.autoCompleteItemsMatches != null && this.state.autoCompleteItemsMatches.count() != 0) {
                this.addSeletedItem();
            }
        }

        // escape
        if (e.keyCode === 27 || e.keyCode === 9) {
            this.mutateState((x: TextboxControlWithSectionsState) => { x.forceHideDropDown = true; });
        }
    }

    // keyboard triggered
    private moveSelectionUpOrDown(IsDirectionUp: boolean): void {
        let collection = this.state.autoCompleteItemsMatches.toArray();
        if (collection.length == 0)
            return;

        let idx = this.indexOfSelectedItem();
        if (idx === -1) {
            collection.forEach(x => x.Active = false);
            collection[IsDirectionUp ? collection.length - 1 : 0].Active = true;
            this.updateAutocompleteMatches(collection);
            return;
        }

        if ((idx === 0 && IsDirectionUp) || (idx === collection.length - 1 && !IsDirectionUp)) {
            return;
        }

        collection[idx].Active = false;
        idx = idx + (IsDirectionUp ? -1 : 1);

        collection[idx].Active = true;
        this.updateAutocompleteMatches(collection);
    }

    private indexOfSelectedItem(): number {
        if (this.state.autoCompleteItemsMatches.count() == 0)
            return -1;

        for (let i = 0; i < this.state.autoCompleteItemsMatches.count(); i++) {
            let item = this.state.autoCompleteItemsMatches.get(i);
            if (item.Active == true) {
                return i;
            }
        }
        return -1;
    }

    private handleItemSelected(item: SearchableItemModelSection<any>): void {
        let newTextboxValue = this.props.onAutoCompleteSelectClearTextBox === true ? "" : item.Value;

        this.mutateState(
            s => {
                s.autoCompleteItemsMatches = [].toImmutable();
                s.forceHideDropDown = false;

                if (this.props.onAutoCompleteSelectDoNotUpdateTextBox != true) {
                    s.text = newTextboxValue;
                }
            },
            () => {
                if (item != null && this.props.onAutoCompleteSelectCallBack != null)
                    this.props.onAutoCompleteSelectCallBack(item.Model, item.Section);
            }
        );
    }

    private addSeletedItem(): void {
        let item = this.state.autoCompleteItemsMatches.filter(x => x.Active == true);
        if (item.count() > 0) {
            this.handleItemSelected(item.get(0));
        }
    }
}

export { TextboxControlWithSections };
